import React, { useState , useEffect } from "react";
import "./Products.css";
import '../Categories.css'
import Card from "../Card";
import { useDispatch, useSelector } from 'react-redux'
import { listproducts } from '../../redux/actions/productAction'

 function Products({handleClick}) {


  //simple step
  // const [data, setData] = useState(productdata);

  // const [data, setData] = useState([]);

  // const  fetchData = async() => {
  //   await fetch('/productsdata.json')
  //     .then((res) => 
  //       res.json())
  //         .then((data) => 
  //           setData(data.productdata)
  //           )
            
  // }


  const dispatch = useDispatch();

  const productContent = useSelector(state => state.productReducer)

  const { product } = productContent

  useEffect(() => {
    // fetchData()
    dispatch(listproducts())
  }, []);
 

  console.log("my data is",product);


  
  const [filter, setFilter] = useState(product)


  const filterItem = (cat) =>{
    const updatedItems = product.filter((curElem) =>(
         curElem.category === cat
       
  ));
  setFilter(updatedItems)
  }





  return (
<>



<div className="home">


<div className='category-box'>
<button className='btn btn-dark' onClick={() => setFilter(product)}>All
  <img className='all' src="https://i.postimg.cc/G3vgdbYQ/kisspng-tote-bag-black-white-m-product-shopping-bag-5c8f7fe606d118-4917142515529082620279.png" alt="allimg"></img>
        </button>
        <button className='btn btn-dark' onClick={() => filterItem('laptop')}>Laptops
        <img src='https://i.postimg.cc/c1zkVsnz/kisspng-asus-rog-strix-scar-ii-gl5-4-i7-875-h-laptop-asus-asus-gl7-3gs-e5-11t-rog-strix-scar-izar-mi.png' alt="lapimg"></img>
        </button>
        <button className='btn btn-dark' onClick={() => filterItem('mobile')}>Mobiles
        <img src='https://i.postimg.cc/4NRY3ckR/i-Phone-14-Pro.png' alt="mobileimg"></img>
        </button>
        <button className='btn btn-dark' onClick={() => filterItem('headsets')}>Headsets
        <img src='https://i.postimg.cc/nhsgwXrM/boat-removebg-preview.png' alt="headsetimg"></img>
        </button>
   </div>

   {/* <Categories filterItem={filterItem} data={product}/> */}


    { filter?.map((item)=>{
      
      return (
<>

<div class="d-inline-flex col-6 col-md-4 col-lg-3 col-xl-3 container-fluid">


<Card handleClick={handleClick} key={item.id} item={item}  />





</div>
</>
      )
 })}


  
</div> 
</>
  );
}

export default Products;
